import { createContext, useContext, useEffect, useState } from "react";
import consts from "../constant";
import usercalls from "../Axios";

export const UserDetails = createContext();

function UserContext({ children }) {
  const [userData, setUserData] = useState();
  const [headerRenderCount, setHeaderRenderCount] = useState(0);
  const path = usercalls();
  const getUserdata = async () => {
    try {
      if (localStorage.getItem("Rikosta")) {
        const response = await path.getCallWithToken({
          url: `${consts.BackendUrl}/users/get_profile`,
        });
        const result = await response.json();
        if (result.success) {
          setUserData(result.result);
        }
      }
    } catch (error) {
      console.log("🚀 ~ getUserdata ~ error:", error);
    }
  };

  useEffect(() => {
    // console.log("ramesh kuamrt")
    if (!userData) {
      getUserdata();
    }
  }, [headerRenderCount]);

  return (
    <UserDetails.Provider value={{ userData, setUserData, setHeaderRenderCount }}>
      {children}
    </UserDetails.Provider>
  );
}
export const useUserData = () => useContext(UserDetails);
export default UserContext;
